import { FetchError } from 'ofetch';
import { ApiResponse } from '..';
import type { HttpClient } from '@/utils/HttpClient';
import { Quote, QuoteCustomItem, QuoteProduct, QuoteResponseEntity } from '~/types/quote';

export const QuoteService = (httpClient: HttpClient) => {
  return {
    getQuoteList(params?: Record<string, any>): ApiResponse<{ data: QuoteResponseEntity[]; totalRecords: number }> {
      return httpClient<{ data: QuoteResponseEntity[]; totalRecords: number }, FetchError>({
        endpoint: '/v1/quotes',
        method: 'GET',
        params,
      });
    },
    deleteQuotes(quoteIds: number[]): ApiResponse<void> {
      return httpClient<void, FetchError>({
        endpoint: `/v1/quotes`,
        method: 'DELETE',
        body: quoteIds,
      });
    },
    createEmptyQuote(): ApiResponse<Quote> {
      return httpClient<Quote, FetchError>({ endpoint: '/v1/quotes', method: 'POST', body: {} });
    },
    getQuoteById(quoteId: string): ApiResponse<Quote> {
      return httpClient<Quote, FetchError>({ endpoint: `/v1/quotes/${quoteId}`, method: 'GET' });
    },
    updateQuote(quoteId: number, payload: Record<string, any>): ApiResponse<void> {
      return httpClient<void, FetchError>({ endpoint: `/v1/quotes/${quoteId}`, method: 'PATCH', body: payload });
    },
    addQuoteItem(quoteId: number, payload: Record<string, any>): ApiResponse<QuoteProduct> {
      return httpClient<QuoteProduct, FetchError>({
        endpoint: `/v1/quotes/${quoteId}/items`,
        method: 'POST',
        body: payload,
      });
    },
    updateQuoteItems(quoteId: number, payload: Record<string, any>[]): ApiResponse<void> {
      return httpClient<void, FetchError>({
        endpoint: `/v1/quotes/${quoteId}/items`,
        method: 'PATCH',
        body: payload,
      });
    },
    deleteQuoteItems(quoteId: number, quoteItemIds: number[]): ApiResponse<void> {
      return httpClient<void, FetchError>({
        endpoint: `/v1/quotes/${quoteId}/items`,
        method: 'DELETE',
        body: quoteItemIds,
      });
    },
    addCustomItem(quoteId: number, payload: Record<string, any>): ApiResponse<QuoteCustomItem> {
      return httpClient<QuoteCustomItem, FetchError>({
        endpoint: `/v1/quotes/${quoteId}/customItems`,
        method: 'POST',
        body: payload,
      });
    },
    updateCustomItem(quoteId: number, payload: Record<string, any>[]): ApiResponse<void> {
      return httpClient<void, FetchError>({
        endpoint: `/v1/quotes/${quoteId}/customItems/`,
        method: 'PATCH',
        body: payload,
      });
    },
    deleteCustomItems(quoteId: number, customItemIds: number[]): ApiResponse<void> {
      return httpClient<void, FetchError>({
        endpoint: `/v1/quotes/${quoteId}/customItems`,
        method: 'DELETE',
        body: customItemIds,
      });
    },
  };
};
